// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__31Tuh","col":"styles_col__24YuE"};